import React, {useEffect, useState} from 'react';
import { Input } from 'antd';
import { Button } from 'antd';
import { Form, Row, Col } from 'antd';
import { DatePicker, Select } from 'antd';

const { Option } = Select;

const StatisticsFilter = (props) => {
    const [expand, setExpand] = useState(false);
    const [name, setName] = useState('');
    const [form] = Form.useForm();

    const getFields = () => {
        const fields = [
            {
                name: 'first_message_date',
                label: 'First response date',
                type: 'date'
            },
            {
                name: 'last_message_date',
                label: 'Last reply date',
                type: 'date'
            },
        ]
        /**/
        const count = expand ? 10 : 6;
        const children = [];
        fields.forEach((item, index) => {
            if (item.type == 'text')
            {
                children.push(
                    <Col span={6} key={index}>
                        <Form.Item
                            name={item.name}
                            label={item.label}
                            rules={[
                                {
                                    required: false,
                                    message: 'Input something!',
                                },
                            ]}
                        >
                            <Input placeholder="" />
                            {/*{item.name == 'date' ? '<DatePicker />':''}*/}
                        </Form.Item>
                    </Col>,
                );
            } else if (item.type == 'date')
            {
                children.push(
                    <Col span={8} key={index}>
                        <Form.Item
                            name={item.name}
                            label={item.label}
                            rules={[
                                {
                                    required: false,
                                    message: 'Input something!',
                                },
                            ]}
                        >
                            <DatePicker />
                        </Form.Item>
                    </Col>,
                );
            } else if (item.type == 'select')
            {
                children.push(
                    <Col span={8} key={index}>
                        <Form.Item
                            name={item.name}
                            label={item.label}
                            rules={[
                                {
                                    required: false,
                                    message: 'Input something!',
                                },
                            ]}
                        >
                            <Select style={{ width: 120 }}>
                                {item.options.map((item, index) => {
                                    return <Option value={item.value}>{item.name}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>,
                );
            }
        })
        return children;
    };

    const onFinish = (values) => {
        if (values.last_message_date)
            values.last_message_date = values.last_message_date.format('YYYY-MM-DD')
        props.onChange(JSON.parse(JSON.stringify(values)))
        if (values.first_message_date)
            values.first_message_date = values.first_message_date.format('YYYY-MM-DD')
        props.onChange(JSON.parse(JSON.stringify(values)))
    };

    return (
        <Form
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form filter-form"
            onFinish={onFinish}
        >
            <Row gutter={24}>{getFields()}</Row>
            <Row>
                <Col span={24} style={{ textAlign: 'right' }}>
                    <button type={'submit'} className={'button'}>
                        Search
                    </button>
                    <button type={'submit'} className={'button'} style={{ margin: '0 8px' }}
                            onClick={() => {
                                form.resetFields();
                            }}>
                        Clear
                    </button>
                </Col>
            </Row>
        </Form>
    );
};


export default StatisticsFilter;